import { Button } from '@nespresso-design-system/components'
import { mgmInteraction } from '@content/helpers/src/gtmEvents'
import './HeroDoubleCta.scss'
import { sanitizeHtml } from '@content/helpers/src/utils.ts'
import { useIsMobile } from '@commons/steps/Steps.tsx'
const HeroDoubleCta = ({ image, ctas }) => {
    const isMobile = useIsMobile()

    const handleClick = (e, link, clickedLabel) => {
        mgmInteraction(clickedLabel)

        if (link.startsWith('#')) {
            e.preventDefault()
            const el = document.getElementById(link.slice(1))
            if (el) {
                const yOffset = -60
                const y =
                    el.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset

                window.scrollTo({ top: y, behavior: 'smooth' })
            }
        } else {
            window.location.href = link
        }
    }

    return (
        <div className="heroDoubleCta">
            <div
                className="heroDoubleCta__img"
                style={
                    image?.desktop?.src
                        ? { backgroundImage: `url(${image.desktop.src})` }
                        : {}
                }
            />
            {ctas.map((cta, index) => (
                <div key={index} className="heroDoubleCta__container">
                    <h3 className="heroDoubleCta__title">
                        {isMobile && cta.titleMobile
                            ? cta.titleMobile
                            : cta.titleDesktop}
                    </h3>
                    <p
                        className="heroDoubleCta__description"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(cta.description)
                        }}
                    />
                    <div className="heroDoubleCta__cta">
                        <Button
                            label={cta.cta.label}
                            variant={cta.cta.variant}
                            onClick={e =>
                                handleClick(e, cta.cta.link, cta.cta.label)
                            }
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default HeroDoubleCta
